<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <div class="md:tw-w-1/3">
          <div class="row tw-h-full">
            <!-- specifications -->
            <section class="md:tw-w-full !tw-mt-3">
              <fieldset class="tw-mb-0">
                <legend class="tw-flex-center tw-py-2">
                  <i class="mdi mdi-message-cog tw-ml-2 mdi-24px"></i>
                  {{ "common.specifications" | translate }}
                </legend>

                <!-- title -->
                <form-field
                  class="tw-w-[275px]"
                  [control]="form?.get('title')"
                  label="common.title"
                  [(value)]="model.title"
                >
                </form-field>
              </fieldset>
            </section>

            <!-- phonebookIds -->
            <section class="md:tw-w-full !tw-mt-3 tw-h-full">
              <fieldset>
                <legend class="tw-flex-center tw-py-2 tw-h-full">
                  <i class="mdi mdi-card-account-phone tw-ml-2 mdi-24px"></i>
                  {{ "common.phonebook" | translate }}
                </legend>

                <!-- phonebookIds -->
                <div [style.height.px]="556" class="tw-contents">
                  <phonebook-selection-list
                    [form]="form"
                    [isShowSelectAll]="!formPageConfig.isEditMode"
                    type="currentOrganizationPhonebooks"
                    [isReadOnly]="this.formPageConfig.isEditMode"
                    controlName="phonebookIds"
                    [showPrivacyDropdown]="false"
                    [isRequired]="true"
                    searchLabel="common.search"
                    (values)="model.phonebookIds = $event"
                    [values]="model.phonebookIds"
                    responsiveClass="tw-w-full"
                    searchBoxGridclass="tw-w-full"
                    [isSmallSize]="true"
                  >
                  </phonebook-selection-list>
                </div>
              </fieldset>
            </section>
          </div>
        </div>

        <div class="md:tw-w-2/3">
          <div class="row messages">
            <!-- enterSms -->
            <section class="md:tw-w-1/2 !tw-mt-3">
              <fieldset class="tw-h-full">
                <legend class="tw-flex-center tw-py-2">
                  <i
                    class="mdi mdi-location-enter tw-ml-2 mdi-24px text-success"
                  ></i>
                  {{ fields + "enterSms" | translate }}
                </legend>

                <app-sms-body
                  [form]="form"
                  smsBodyControlName="enterSms"
                  [isAddSignature]="false"
                  [isAddHeader]="false"
                  [isShowSenderNumberId]="false"
                  [smsBodyRow]="6"
                  [isShowSmsTemplate]="false"
                  [smsBody]="enterSms"
                  (finalSmsBody)="model.enterSms = $event"
                  (smsBody)="enterSms = $event"
                >
                </app-sms-body>
              </fieldset>
            </section>

            <!-- exitSms -->
            <section class="md:tw-w-1/2 !tw-mt-3">
              <fieldset class="tw-h-full">
                <legend class="tw-flex-center tw-py-2">
                  <i
                    class="mdi mdi-location-exit tw-ml-2 mdi-24px text-danger"
                  ></i>
                  {{ fields + "exitSms" | translate }}
                </legend>

                <app-sms-body
                  [form]="form"
                  smsBodyControlName="exitSms"
                  [isAddSignature]="false"
                  [isAddHeader]="false"
                  [isShowSenderNumberId]="false"
                  [smsBodyRow]="6"
                  [isShowSmsTemplate]="false"
                  [smsBody]="exitSms"
                  (finalSmsBody)="model.exitSms = $event"
                  (smsBody)="exitSms = $event"
                >
                </app-sms-body>
              </fieldset>
            </section>

            <!-- returnText -->
            <section class="md:tw-w-1/2 !tw-mt-3">
              <fieldset class="tw-h-full">
                <legend class="tw-flex-center tw-py-2">
                  <i
                    class="mdi mdi-rotate-180 mdi-keyboard-return tw-ml-2 mdi-24px text-blue"
                  ></i>
                  {{ fields + "returnText" | translate }}
                </legend>

                <app-sms-body
                  [form]="form"
                  smsBodyControlName="returnText"
                  [isAddSignature]="false"
                  [isAddHeader]="false"
                  [isShowSenderNumberId]="false"
                  [smsBodyRow]="6"
                  [isShowSmsTemplate]="false"
                  [smsBody]="returnText"
                  (finalSmsBody)="model.returnText = $event"
                  (smsBody)="returnText = $event"
                >
                </app-sms-body>
              </fieldset>
            </section>

            <!-- cancelText -->
            <section class="md:tw-w-1/2 !tw-mt-3">
              <fieldset class="tw-h-full">
                <legend class="tw-flex-center tw-py-2">
                  <i class="mdi mdi-cancel tw-ml-2 mdi-24px text-danger"></i>
                  {{ fields + "cancelText" | translate }}
                </legend>

                <app-sms-body
                  [form]="form"
                  smsBodyControlName="cancelText"
                  [isAddSignature]="false"
                  [isAddHeader]="false"
                  [isShowSenderNumberId]="false"
                  [smsBodyRow]="6"
                  [isShowSmsTemplate]="false"
                  [smsBody]="cancelText"
                  (finalSmsBody)="model.cancelText = $event"
                  (smsBody)="cancelText = $event"
                >
                </app-sms-body>
              </fieldset>
            </section>
          </div>
        </div>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
